export default __webpack_public_path__ + "static/2-science-fiction-475f976feb358f0781049a4ee3b0d059.png";